<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="container">
            <div class="footer-info">
                <div class="copy">
                    <p>{{setup.sales_setup_new_corp.copyright}}</p>
                    <a href="https://sales.bazis.kz/privacy-policy" target="_blank" class="link-to-policy" v-if="projectHost != 'nurly-dala2'">
                        <span v-if="lang == ''">Политика конфиденциальности</span>
                        <span v-else>Құпиялылығы саясаты</span>
                    </a>
                </div>
                <div class="logo-bazis">
                    <a href="https://sales.bazis.kz" target="_blank">
                        <img src="https://admin.sales.bazis.kz/media/bazis-logo_2023.svg" alt="sales.bazis.kz BAZIS-A">
                    </a>
                </div>
                <div class="copy-mobile">
                    <p>{{setup.sales_setup_new_corp.copyright}}</p>
                    <a href="https://sales.bazis.kz/privacy-policy" target="_blank" class="link-to-policy" v-if="projectHost != 'nurly-dala2'">
                        <span v-if="lang == ''">Политика конфиденциальности</span>
                        <span v-else>Құпиялылығы саясаты</span>
                    </a>
                </div>
                <div class="made-in">
                    <p>Developed by</p>
                    <a href="https://v-web.kz" target="_blank">Victory WEB</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import formFooterMail from '@/components/forms/form-footer-mail.vue'
    export default {
        name: 'AppFooter',
        data () {
            return {
                projectHost: window.host,
                lang: window.GlobalLang,
            }
        },
        components: {
            // formFooterMail,
        },
        methods: {
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
    @import '@/styles/respond/footer/respond-footer.scss';
</style>